export default "__VITE_ASSET__4db07335__"